import { deepClonedState, dispatch, state } from '__common/store';
import { getProductName, isAscender } from '__common/constants/products';
import { parseDataForBomSave } from '../bomHelpers';
import { SAVE_BOM, SAVE_BOM_AND_DOWNLOAD_BOM_PDF, SET_BOM_PK } from 'actions';
import { AUTO_SAVE_BOM } from 'bom/bomActions';

export function saveBom(dontRedirect = false) {
  const { bom: { partsList, extraParameters, productId, projectId, bomSelectionsLoading, stdClampsFetching, bomChanged, created, }, railsSelector: { railsList, railsFetching, selectOnlySMHDRails }, projectConfiguration: { projectId: configProjectId, productId: configProductId } } = deepClonedState();
  const finalProjectId = projectId || configProjectId;
  const finalProductId = productId || configProductId;

  if (!finalProjectId) {
    console.warn('saveBom: projectId is empty, aborting save.');
    return;
  }

  const bomSaveRequestBody = parseDataForBomSave(partsList, railsList, extraParameters, finalProductId, selectOnlySMHDRails);

  if ((!partsList.length && !isAscender
    (finalProductId)) || bomSelectionsLoading || stdClampsFetching || railsFetching || !validatePartListQty()) {
    return;
  }

  if (!dontRedirect && !bomChanged && !created) {
    return dispatch(SET_BOM_PK(finalProjectId));
  }

  dispatch(SAVE_BOM(getProductName(finalProductId), finalProjectId, bomSaveRequestBody, dontRedirect));
}

// copy pasted from above, to do some day after release
export function autoSaveBom(dontRedirect = false) {
  const { bom: { partsList, extraParameters, productId, projectId, bomSelectionsLoading, stdClampsFetching, bomChanged, created,}, railsSelector: { railsList, railsFetching, selectOnlySMHDRails }, projectConfiguration: { projectId: configProjectId, productId: configProductId } } = deepClonedState();
  const finalProjectId = projectId || configProjectId;
  const finalProductId = productId || configProductId;

  if (!finalProjectId) {
    console.warn('autoSaveBom: projectId is empty, aborting save.');
    return;
  }

  const bomSaveRequestBody = parseDataForBomSave(partsList, railsList, extraParameters, finalProductId, selectOnlySMHDRails);

  if ((!partsList.length && !isAscender
    (finalProductId)) || bomSelectionsLoading || stdClampsFetching || railsFetching || !validatePartListQty()) {
    return;
  }

  if (!dontRedirect && !bomChanged && !created) {
    return dispatch(SET_BOM_PK(finalProjectId));
  }

  dispatch(AUTO_SAVE_BOM(getProductName(finalProductId), finalProjectId, bomSaveRequestBody, dontRedirect));
}

export function saveBomAndDownloadPdf() {
  const { bom: { partsList, extraParameters, productId, projectId, bomSelectionsLoading, stdClampsFetching }, railsSelector: { railsList, railsFetching, selectOnlySMHDRails }, projectConfiguration: { projectId: configProjectId, productId: configProductId } } = deepClonedState();
  const finalProjectId = projectId || configProjectId;
  const finalProductId = productId || configProductId;

  if (!finalProjectId) {
    console.warn('saveBomAndDownloadPdf: projectId is empty, aborting.');
    return;
  }

  const bomSaveRequestBody = parseDataForBomSave(partsList, railsList, extraParameters, finalProductId, selectOnlySMHDRails);
 
  if (!partsList.length || bomSelectionsLoading || stdClampsFetching || railsFetching || !validatePartListQty()) {
    return;
  }

  dispatch(SAVE_BOM_AND_DOWNLOAD_BOM_PDF(getProductName(finalProductId), finalProjectId, bomSaveRequestBody));
}

function validatePartListQty() {
  const { bom: { partsList } } = state();
  return partsList.every(part => {
    if (!part) return false;
    const qty: any = part.quantity; // qty can be string ;()
    if (qty === undefined || qty === null) return false;
    if (qty.constructor === Number) {
      return qty > -1;
    }

    if (qty.constructor === String) {
      return qty.length;
    }
    return false;
  });
}
